import {
  AddIteractionCheckBoxRequestPayload,
  treeDataInterface,
} from 'Interfaces/BDPortalInterfaces/AddNewIterationInterfaces';

export const createEmptyRequestPayloadForAddIteration = () => {
  const data: AddIteractionCheckBoxRequestPayload = {
    Description: false,
    NadWaiver: false,
    SiteTransfer: false,
    EstAnnualRevenue: false,
    EstGrossProfit: false,
    LaunchDate: false,
    SolicitationNumber: false,
    SubmissionDueDate: false,
    ReverseAction: false,
    Negotiation: false,
    NegotiationDate: false,
    FPRDate: false,
    AwardDate: false,
    AwardedValue: false,
    GSMSBidValue: false,
    OpportunityIterationsID: -1,
    AnalystID: false,
    AccountManagerID: false,
    StrategyID: false,
    AgencyID: false,
    PrimarySupplierID: false,
    BackupSupplierID1: false,
    BackupSupplierID2: false,
    NCBidStatusID: false,
    AwardingAgencyID: false,
    AwardeeID: false,
    SourceID: false,
    OpportunityID: -1,
    concepts: false,
    old_board_type: '',
    new_board_type: '',
  };
  return data;
};

export const AddIterationNodeServices = {
  getTreeNodesData() {
    const data: treeDataInterface[] = [
      {
        key: '0',
        label: 'Basic Details',
        data: 'Documents Folder',
        children: [
          {
            key: '0-0',
            label: 'Strategy',
            data: 'StrategyID',
          },
          {
            key: '0-1',
            label: 'Agency',
            data: 'AgencyID',
          },
          {
            key: '0-2',
            label: 'NAD Waiver',
            data: 'NadWaiver',
          },
          {
            key: '0-3',
            label: 'Site Transfer',
            data: 'SiteTransfer',
          },
        ],
      },
      {
        key: '1',
        label: 'Partners',
        data: 'Events Folder',
        children: [
          {
            key: '1-0',
            label: 'Primary Partner',
            data: 'PrimarySupplierID',
          },
          {
            key: '1-1',
            label: 'Backup Partner 1',
            data: 'BackupSupplierID1',
          },
          {
            key: '1-2',
            label: 'Backup Partner 2',
            data: 'BackupSupplierID2',
          },
        ],
      },
      {
        key: '2',
        label: 'Financials',
        data: '',
        children: [
          {
            key: '2-0',
            label: 'Estimated Annual Revenue',
            data: 'EstAnnualRevenue',
          },
          {
            key: '2-1',
            label: 'ESTIMATED ANNUAL GP',
            data: 'EstGrossProfit',
          },
          {
            key: '2-2',
            label: 'Launch Date',
            data: 'LaunchDate',
          },
        ],
      },
      {
        key: '3',
        label: 'NC Details',
        data: 'Movies Folder',
        className: '',
        children: [
          {
            key: '3-0',
            label: 'NC BID STATUS',
            data: 'NCBidStatusID',
          },
          {
            key: '3-1',
            label: 'SOLICITATION NUMBER',
            data: 'SolicitationNumber',
          },
          {
            key: '3-2',
            label: 'SUBMISSION DUE DATE',
            data: 'SubmissionDueDate',
          },
          {
            key: '3-3',
            label: 'AWARDING AGENCY',
            data: 'AwardingAgencyID',
          },
          {
            key: '3-4',
            label: 'REVERSE AUCTION',
            data: 'ReverseAction',
          },
          {
            key: '3-5',
            label: 'NEGOTIATION',
            data: 'Negotiation',
          },
          {
            key: '3-6',
            label: 'NEGOTIATIONS DATE',
            data: 'NegotiationDate',
          },
          {
            key: '3-7',
            label: 'FPR DATE',
            data: 'FPRDate',
          },
          {
            key: '3-8',
            label: 'AWARD DATE',
            data: 'AwardDate',
          },
          {
            key: '3-9',
            label: 'AWARDEE',
            data: 'AwardeeID',
          },
          {
            key: '3-10',
            label: 'AWARDED VALUE',
            data: 'AwardedValue',
          },
          {
            key: '3-11',
            label: 'GSMS BID VALUE',
            data: 'GSMSBidValue',
          },
        ],
      },
      {
        key: '4',
        label: 'Analyst',
        data: 'AnalystID',
      },
      {
        key: '5',
        label: 'Account Manager',
        data: 'AccountManagerID',
      },
      {
        key: '6',
        label: 'Concepts',
        data: 'concepts',
      },
      {
        key: '7',
        label: 'Description',
        data: 'Description',
      },
    ];
    return data;
  },

  getTreeNodes() {
    return Promise.resolve(this.getTreeNodesData());
  },
};
